import { CouponDiscountCurrency, CouponDiscountType } from './'

export interface FindCouponsParams {
  userId?: number
  couponTemplateId?: string
  couponId?: string
  userNickname?: string
  page?: number
  size?: number
}

export enum CouponStatus {
  ISSUED = 'ISSUED',
  FORCE_ISSUED = 'FORCE_ISSUED',
  REDEEMED = 'REDEEMED',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
}

export interface AdminCouponResponse {
  userId: number
  userNickname: string
  couponId: string
  couponTemplateId: string
  status: CouponStatus
  title: string
  endExpiryDateTimeUtc: string
  discountType: CouponDiscountType
  discount: number
  maxDiscountAmount: number
  currency: string
  Enum: CouponDiscountCurrency
  createdBy: number
  updatedBy: number
  createdAt: string
  updatedAt: string
}
